import { useEffect, useState } from 'react';

export function useDynamicHeight(offsetHeight: number) {
  const [height, setHeight] = useState<string | number>('auto');

  useEffect(() => {
    const handleResize = () => {
      const windowHeight = window.innerHeight;
      const newHeight = windowHeight - offsetHeight;

      setHeight(newHeight);
    };

    handleResize(); // Initial height calculation

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [offsetHeight]);

  return height;
}
